/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Device_OffInputs */

const th_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปิดอยู่`)
};

const en_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Off`)
};

const ja_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフ`)
};

const zh_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭`)
};

const es_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desactivado`)
};

const pt_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desligado`)
};

const id_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mati`)
};

const fr_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désactivé`)
};

const tl_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patay`)
};

const vi_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tắt`)
};

const ko_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`꺼짐`)
};

const de_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus`)
};

const ru_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выкл.`)
};

const tr_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapalı`)
};

const it_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disattivate`)
};

const pl_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyłączone`)
};

const uk_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вимкнено`)
};

const hi_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद`)
};

const ar_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`موقوفة`)
};

const ms_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mati`)
};

const bn_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বন্ধ`)
};

const zh_tw2_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`關閉`)
};

const zh_hk2_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`關閉`)
};

const ur_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بند`)
};

const fa_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خاموش`)
};

const sw_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imezimwa`)
};

const nl_device_off = /** @type {(inputs: Device_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uit`)
};

/**
* | output |
* | --- |
* | "Off" |
*
* @param {Device_OffInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const device_off = /** @type {((inputs?: Device_OffInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Device_OffInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_device_off(inputs)
	if (locale === "ja") return ja_device_off(inputs)
	if (locale === "zh") return zh_device_off(inputs)
	if (locale === "es") return es_device_off(inputs)
	if (locale === "pt") return pt_device_off(inputs)
	if (locale === "id") return id_device_off(inputs)
	if (locale === "fr") return fr_device_off(inputs)
	if (locale === "tl") return tl_device_off(inputs)
	if (locale === "vi") return vi_device_off(inputs)
	if (locale === "ko") return ko_device_off(inputs)
	if (locale === "de") return de_device_off(inputs)
	if (locale === "ru") return ru_device_off(inputs)
	if (locale === "tr") return tr_device_off(inputs)
	if (locale === "it") return it_device_off(inputs)
	if (locale === "pl") return pl_device_off(inputs)
	if (locale === "uk") return uk_device_off(inputs)
	if (locale === "hi") return hi_device_off(inputs)
	if (locale === "ar") return ar_device_off(inputs)
	if (locale === "ms") return ms_device_off(inputs)
	if (locale === "bn") return bn_device_off(inputs)
	if (locale === "zh-TW") return zh_tw2_device_off(inputs)
	if (locale === "zh-HK") return zh_hk2_device_off(inputs)
	if (locale === "ur") return ur_device_off(inputs)
	if (locale === "fa") return fa_device_off(inputs)
	if (locale === "sw") return sw_device_off(inputs)
	if (locale === "nl") return nl_device_off(inputs)
	return en_device_off(inputs)
});